import { render, staticRenderFns } from "./ChannelProductListAssociationView.vue?vue&type=template&id=e6ddaf52&scoped=true&"
import script from "./ChannelProductListAssociationView.vue?vue&type=script&lang=js&"
export * from "./ChannelProductListAssociationView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelProductListAssociationView.vue?vue&type=style&index=0&id=e6ddaf52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ddaf52",
  null
  
)

export default component.exports